import { render, staticRenderFns } from "./UserOnboardingDocumentPdf.vue?vue&type=template&id=6e43a676&scoped=true"
import script from "./UserOnboardingDocumentPdf.vue?vue&type=script&lang=js"
export * from "./UserOnboardingDocumentPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e43a676",
  null
  
)

export default component.exports